module.exports = __webpack_public_path__ + "img/indonesia_center.bdb2856f.jpg";